import styled from 'styled-components'

import Picture from '../../atoms/Picture'
import Html from '../../atoms/Html'
import FormSubmitButton from '../../form/FormSubmitButton'
import FormikForm from '../../form/FormikForm'
import { ErrorMessage } from '../../form/fields/FormFieldInput/styled'
import ActionButton from '../../atoms/ActionButton'

export const Main = styled.aside`
  border-radius: 2rem;
  overflow: hidden;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
`

export const BackgroundImage = styled(Picture)`
  width: 100%;
  height: 16.3rem;
  & img {
    object-fit: cover;
    width: 100%;
    height: 100%;
    max-width: initial;
    max-height: initial;
  }
`

export const Content = styled.div`
  position: relative;
  padding: 3.2rem 2.4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 1.5rem;
  background-color: ${({ theme }) => theme.colors.tangerineYellow};
`

export const Title = styled.div`
  ${({ theme }) => theme.textStyles.titleH4}
  color: ${({ theme }) => theme.colors.arapawa};
  margin-bottom: -1.5rem;
`
export const BMI = styled.div`
  ${({ theme }) => theme.textStyles.titleH1}
  color: ${({ theme }) => theme.colors.killarney};
`

export const Text = styled(Html)`
  ${({ theme }) => theme.textStyles.textMediumStrong}
  color: ${({ theme }) => theme.colors.arapawa};
`

export const Value = styled.div`
  ${({ theme }) => theme.textStyles.titleH1}
  color: ${({ theme }) => theme.colors.killarney};
`
export const Restart = styled(ActionButton)``

export const Form = styled(FormikForm)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  & ${ErrorMessage} {
  }
`

export const Submit = styled(FormSubmitButton)``
